<template>
    <div class="footer">
        <div class="item active" v-if="$route.path == '/home'">
            <img src="@/assets/c/icon_home_s.png" alt="" />
            <p>{{ $t("new.bone") }}</p>
        </div>
        <div class="item" v-else @click="toPage(1, '/home')">
            <img src="@/assets/c/icon_home_n.png" alt="" />
            <p>{{ $t("new.bone") }}</p>
        </div>
        <div class="item active" v-if="$route.path == '/node'">
            <img src="@/assets/c/icon_jd_s.png" alt="" />
            <p>{{ $t("new.btwo") }}</p>
        </div>
        <div class="item" v-else @click="toPage(2, '/node')">
            <img src="@/assets/c/icon_jd_n.png" alt="" />
            <p>{{ $t("new.btwo") }}</p>
        </div>

        <div class="item active" v-if="$route.path == '/ico'">
            <img src="@/assets/c/icon_ico_s.png" alt="" />
            <p>ICO</p>
        </div>
        <div class="item" v-else @click="toPage(3, '/ico')">
            <img src="@/assets/c/icon_ico_n.png" alt="" />
            <p>ICO</p>
        </div>
        <div class="item active" v-if="$route.path == '/mine'">
            <img src="@/assets/c/icon_wd_s.png" alt="" />
            <p>{{ $t("new.bthree") }}</p>
        </div>
        <div class="item" v-else @click="toPage(4, '/mine')">
            <img src="@/assets/c/icon_wd_n.png" alt="" />
            <p>{{ $t("new.bthree") }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            index: 1,
        };
    },
    methods: {
        toPage(index, path) {
            this.index = index;
            this.$router.push(path);
        },
    },
};
</script>

<style lang='less' scoped>
.footer {
    width: 100vw;
    height: 70px;
    z-index: 100;
    // padding-bottom: 34px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    box-shadow: 0px -1px 0px 0px #e7eaed;
    .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
        font-weight: bold;
        font-size: 12px;
        color: #a2aab4;
        .icon {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #f3cf45;
        }
        img {
            width: 25px;
            height: 25px;
            margin-bottom: 3px;
        }
    }

    .active {
        color: #000000;
    }
}
</style>